import { convertToFiberName } from '../../lib';
import { IMapFeatureUIState } from '../store';

export const getSourceLayerID = (state: IMapFeatureUIState, sourceID: string): string => {
	const { layers, sources } = state.mapFeatures;
	const source = sources.find((source) => source.id === sourceID);
	const layer = layers.find((layer) => convertToFiberName(layer.name) === source.data.source_layer);

	return layer?.id;
};

export const isRequestingUpdateLayer = (state: IMapFeatureUIState): boolean => {
	const { requestingUpdateLayer } = state.mapFeatures;

	return requestingUpdateLayer;
};
